import { Box } from '@sbv-clients/ui-shared';

import FacilityGrid from './facility-grid';

export const ListFacilityPage = () => {
  return (
    <Box p={2} height="100%">
      <FacilityGrid />
    </Box>
  );
};
